import { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core'
import Col from 'shared-components/col'

const useStyle = makeStyles({
	root: {
		width: '100vw',
		backgroundColor: '#fff',
	},
})

interface IProps {
	children: ReactElement[] | ReactElement | null
}

export default function QuizWrapper(props: IProps): ReactElement {
	const classes = useStyle()

	return (
		<Col className={classes.root}>
			{props.children}
		</Col>
	)
}